import React, { useState, useEffect } from "react";
import { fetchAPI, METHODS } from "../../../helper/functions/axios";
const BlobImage = (props) => {
    const [imgSource, setImageSource] = useState<string>('');
    useEffect(() => {
        fetchAPI(METHODS.CONFIG,props.url,{ method: "GET",responseType: "blob"})
            .then(res => {
                if (res.data) {
                    const url = URL.createObjectURL(new Blob([res.data]));
                    setImageSource(url);
                }
            });
    }, [props.url]);
    return <img key={props.url} src={imgSource} alt={props.key} />
}
export default BlobImage;